import { useResizeObserver } from "@smartsheet/lodestar-utils";
import { Ref, useCallback, useState } from "react";

export type UseHorizontalResizeProps = {
    initialWidth?: number;
};

export type UseHorizontalResizeResult<ElementType extends HTMLElement> = {
    ref: Ref<ElementType>;
    width: number;
};

export const useHorizontalResize = <ElementType extends HTMLElement>({
    initialWidth = 0,
}: UseHorizontalResizeProps = {}): UseHorizontalResizeResult<ElementType> => {
    const [width, setWidth] = useState(initialWidth);
    const { ref } = useResizeObserver(
        useCallback((entry) => {
            const newHorizontalSize = entry[0].borderBoxSize[0].inlineSize;
            if (newHorizontalSize) {
                setWidth(newHorizontalSize);
            }
        }, [])
    );

    return {
        ref,
        width,
    };
};
